import { isUndNullEmp, getResponse, settings } from '../../helpers/main.js';

export class PaymentInformation {
    constructor(
        _id = 0,
        _name = '',
        _logo = '',
        _register = '',
    ) {
        this.id = _id;
        this.name = _name;
        this.logo = _logo;
        this.register = _register;
    }

    static getClassName = () => {
        return 'PaymentInformation - class';
    }

    static minMaxLength = (upperCase = false) => {
        if (upperCase) {
            return {
                min: {
                    Id: 0,
                    Name: 2,
                    Logo: 0,
                    Register: 10,
                },
                max: {
                    Id: 450,
                    Name: 100,
                    Logo: 500,
                    Register: 30,
                },
            };
        } else {
            return {
                min: {
                    id: 0,
                    name: 2,
                    logo: 0,
                    register: 10,
                },
                max: {
                    id: 450,
                    name: 100,
                    logo: 500,
                    register: 30,
                },
            };
        }
    }

    static logoFullPath = ({ logo = '', subMethod = '' } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'PaymentInformation / logoFullPath';
        try {
            if (!isUndNullEmp({ data: logo, subMethod: currentMethod })?.result) {
                logo = logo.replace('~/Images/Logos/PaymentInformation/', `${settings?.backend?.urls?.imageLogos}${settings?.backend?.urls?.paymentInformations}/`);
                response.result = `${settings?.backend?.urls?.api}${logo}`
            } else {
                response.result = `${settings?.backend?.urls?.api}${settings?.images?.noImage}`;
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    static class = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: PaymentInformation.getClassName() })?.result) {
            if (upperCase) {
                return new PaymentInformation(
                    obj.Id,
                    obj.Name,
                    obj.Logo,
                    obj.Register,
                );
            } else {
                return new PaymentInformation(
                    obj.id,
                    obj.name,
                    obj.logo,
                    obj.register,
                );
            }
        } else {
            return new PaymentInformation();
        }
    }
}

export class PaymentInformationWithDetails {
    constructor(
        _id = 0,
        _name = '',
        _logo = '',
        _accounts = [],
        _register = '',
    ) {
        this.id = _id;
        this.name = _name;
        this.logo = _logo;
        this.accounts = _accounts;
        this.register = _register;
    }

    static getClassName = () => {
        return 'PaymentInformationWithDetails - class';
    }

    static minMaxLength = (upperCase = false) => {
        if (upperCase) {
            return {
                min: {
                    Id: 0,
                    Name: 2,
                    Logo: 0,
                    Accounts: 0,
                    Register: 10,
                },
                max: {
                    Id: 450,
                    Name: 100,
                    Logo: 500,
                    Accounts: 450,
                    Register: 30,
                },
            };
        } else {
            return {
                min: {
                    id: 0,
                    name: 2,
                    logo: 0,
                    accounts: 0,
                    register: 10,
                },
                max: {
                    id: 450,
                    name: 100,
                    logo: 500,
                    accounts: 450,
                    register: 30,
                },
            };
        }
    }

    static class = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: PaymentInformationWithDetails.getClassName() })?.result) {
            if (upperCase) {
                return new PaymentInformationWithDetails(
                    obj.Id,
                    obj.Name,
                    obj.Logo,
                    obj.Accounts,
                    obj.Register,
                );
            } else {
                return new PaymentInformationWithDetails(
                    obj.id,
                    obj.name,
                    obj.logo,
                    obj.accounts,
                    obj.register,
                );
            }
        } else {
            return new PaymentInformationWithDetails();
        }
    }
}